import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetSearchList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_SEARCH_REPORT_GAMES
            });

            if (data.status === 'success') {
                const games = [...getState().providerMobile.search.data];
                games.push(data.data);

                dispatch(Action.SetGetSearchListAction({
                    data: games.flat(1),
                    countPage: data.countPage
                }));
                dispatch(Action.SetLoadingAction(false))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetSearchList as SetGetSearchList
}